
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cartAhzxZG11on8GmWPY1aBTu7ufBA2sygxDaBWb0u05upoMeta } from "/var/www/app/apps/web/pages/cart.vue?macro=true";
import { default as index0h59zD_yKOMbqRwgvieNzNyl231KAfLBdgTk5KjtWdYMeta } from "/var/www/app/apps/web/pages/index.vue?macro=true";
import { default as loginOcfyw79BVW5W4BN_45INBfx3vUg6out0UGWb6MdSQRkqkMeta } from "/var/www/app/apps/web/pages/login.vue?macro=true";
import { default as searchhmqhNojoIUTAyO0tR7ZVvA8SyvHA7Se5xJOwPEbJifEMeta } from "/var/www/app/apps/web/pages/search.vue?macro=true";
import { default as signuphyZ8GbguPVcPmqpPhaqi3pf_Rnqh_8fxK8YK5hVHgHYMeta } from "/var/www/app/apps/web/pages/signup.vue?macro=true";
import { default as offlineJDuYKW8qE97I9SFERJM_B5Pl8qJqQCvCVpuvFxGDstoMeta } from "/var/www/app/apps/web/pages/offline.vue?macro=true";
import { default as checkout_MyBoMLOVi14q2Tw5rSu8N9tMQzvqSxCSehoNf0_WWsMeta } from "/var/www/app/apps/web/pages/checkout.vue?macro=true";
import { default as configureQYMeiqRJsDEwh3b_45DOw1dKcwctDf77kMLRRrwW3h6hMMeta } from "/var/www/app/apps/web/pages/configure.vue?macro=true";
import { default as error_454012R3QDbMGdWp9I_bEcP5Oa9VqeFXGvXTprWgJAofpyVgMeta } from "/var/www/app/apps/web/pages/error-401.vue?macro=true";
import { default as categoriesBybHm_jJ8ogK850lSE5pliKF1kRLktMj2sE2x7CONmgMeta } from "/var/www/app/apps/web/pages/categories.vue?macro=true";
import { default as contact_45usxDczjWoCkTlXIs78mVbEZVDdhcqjQ8GA5PZwOqABxYYMeta } from "/var/www/app/apps/web/pages/contact-us.vue?macro=true";
import { default as failedde9f5IH3QPTzPY830fzv7LZAZEbmZ5Qq2Wv_45bWVPesIMeta } from "/var/www/app/apps/web/pages/order/failed.vue?macro=true";
import { default as find_45a_45dealerQqLLAsbcIk7UaBAoEm8pHG26S0ZtQrhUGJqn1H_FeEgMeta } from "/var/www/app/apps/web/pages/find-a-dealer.vue?macro=true";
import { default as success26CkGdzdsmwgmQjjgTiJeBv0h_muWmxvWy_MgquP0I0Meta } from "/var/www/app/apps/web/pages/order/success.vue?macro=true";
import { default as _91slug_93vS5_e1UzdHV_mvJve9HvVtMi7jZLFvso1MICV1dAcCwMeta } from "/var/www/app/apps/web/pages/product/[slug].vue?macro=true";
import { default as reset_45passwordmBrqHg8pYn7o11_451JtiBIJM2AHi_45l8Ivc0Iiqc9wTx8Meta } from "/var/www/app/apps/web/pages/reset-password.vue?macro=true";
import { default as become_45a_45dealerBB12j70_XGPazZ3ri16yk3aMl2DvLq1eICL6qgpfquIMeta } from "/var/www/app/apps/web/pages/become-a-dealer.vue?macro=true";
import { default as build_45your_45bikenVc0nOrNqGQ4uXFJ0KYQ4u94DInOadN6i2JhOFLmbPUMeta } from "/var/www/app/apps/web/pages/build-your-bike.vue?macro=true";
import { default as _91slug_93VVDQAJO_8wtIELIBoeQY2j1ZREtphxSKERnpGjyBANoMeta } from "/var/www/app/apps/web/pages/category/[slug].vue?macro=true";
import { default as indexE1s0bDIlVQ8qkcUbXNLdTT93epfXpQT7gVq3lLotZ3oMeta } from "/var/www/app/apps/web/pages/my-account/index.vue?macro=true";
import { default as set_45new_45passwordijBK_uSvyutqwZjksUBIcg3Hx5Wk5xaazm6hOAiWC4wMeta } from "/var/www/app/apps/web/pages/set-new-password.vue?macro=true";
import { default as returnst9vSGFJtHHs6_LYG1UU_45Tg3ddE_MtbDTTizDwkQ1qgYMeta } from "/var/www/app/apps/web/pages/my-account/returns.vue?macro=true";
import { default as my_45salesOL2sv20rZi52soJuPdz2gpptUK9p8dj08_suNA4jK4QMeta } from "/var/www/app/apps/web/pages/my-account/my-sales.vue?macro=true";
import { default as warrantyLeX_96ME7yFpuVllzbT_45RtteNWozyBjuvGVVMLXqxBMMeta } from "/var/www/app/apps/web/pages/my-account/warranty.vue?macro=true";
import { default as my_45account3n9vJbS_459OmkKd5UuWtIdF4Xp9cdRtukob8SA7CngNQMeta } from "/var/www/app/apps/web/pages/my-account/my-account.vue?macro=true";
import { default as saved_45cartecT1KF4w8sO7Tf9kmvGuzugJgEQmOihQczcPb1UieX8Meta } from "/var/www/app/apps/web/pages/my-account/saved-cart.vue?macro=true";
import { default as reset_45password_45successIXp7Q5crUcCnVN5i_45YPP3H2KDo0v1jai5agU_45n2teccMeta } from "/var/www/app/apps/web/pages/reset-password-success.vue?macro=true";
import { default as my_45customersB9pC5qLohNIAYF12rv22y_45Edl7owH1qRfnOq7sbZs2UMeta } from "/var/www/app/apps/web/pages/my-account/my-customers.vue?macro=true";
import { default as my_45dashboardw_y7nzY6G3l2YD_NhfGxAzqbpCiuxl7MyCmLK6E_45hqMMeta } from "/var/www/app/apps/web/pages/my-account/my-dashboard.vue?macro=true";
import { default as my_45discountsaRjSlwl5TrNek3wIhcG1htmHAS7HIEDGPutL7LOvn2AMeta } from "/var/www/app/apps/web/pages/my-account/my-discounts.vue?macro=true";
import { default as _91id_93_453KYzKJHgMNzJ4YBpNSwZ9f5JGjW1BPv7Mvq1sWYFrEMeta } from "/var/www/app/apps/web/pages/my-account/my-quote/[id].vue?macro=true";
import { default as personal_45data0GsQYz8jDOzqox3lGJ29mGEsHVj2Y6DYyNN12O6ZFO8Meta } from "/var/www/app/apps/web/pages/my-account/personal-data.vue?macro=true";
import { default as _91id_93pNeNeXBz39N_45xEGDHmmVMxxc1J_xyNaKQWlxgv0OeagMeta } from "/var/www/app/apps/web/pages/my-account/my-orders/[id].vue?macro=true";
import { default as indexCJQX2L1bvMl1i7xHMhei6r1On4Oz4VK7hSuczprCbMoMeta } from "/var/www/app/apps/web/pages/my-account/my-quote/index.vue?macro=true";
import { default as billing_45details_oEI855yh4ts_45mKTzHn8O_45WdEXG8ZoPtkvx_45W1mov3wMeta } from "/var/www/app/apps/web/pages/my-account/billing-details.vue?macro=true";
import { default as index6Hj89KT0Twuvcp8y7ZpTUZHGgaEE6oC3FlPsxonGo0UMeta } from "/var/www/app/apps/web/pages/my-account/my-orders/index.vue?macro=true";
import { default as _91id_93He_45YRrzUU7p8JQplufUM8tIIy2FoSXRjNMl2VaukeI4Meta } from "/var/www/app/apps/web/pages/my-account/my-invoices/[id].vue?macro=true";
import { default as shipping_45detailsw9CK_m7zTtcp4bj_45S7q_7e_knzADzn1AeMwYMHCSXWMMeta } from "/var/www/app/apps/web/pages/my-account/shipping-details.vue?macro=true";
import { default as indexpt7sEySxTygmRlWZw2oorNCs0jgpUc_esJAMFU119EcMeta } from "/var/www/app/apps/web/pages/my-account/my-invoices/index.vue?macro=true";
export default [
  {
    name: "cart___en",
    path: "/cart",
    meta: cartAhzxZG11on8GmWPY1aBTu7ufBA2sygxDaBWb0u05upoMeta || {},
    component: () => import("/var/www/app/apps/web/pages/cart.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/var/www/app/apps/web/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: loginOcfyw79BVW5W4BN_45INBfx3vUg6out0UGWb6MdSQRkqkMeta || {},
    component: () => import("/var/www/app/apps/web/pages/login.vue")
  },
  {
    name: "search___en",
    path: "/search",
    meta: searchhmqhNojoIUTAyO0tR7ZVvA8SyvHA7Se5xJOwPEbJifEMeta || {},
    component: () => import("/var/www/app/apps/web/pages/search.vue")
  },
  {
    name: "signup___en",
    path: "/signup",
    meta: signuphyZ8GbguPVcPmqpPhaqi3pf_Rnqh_8fxK8YK5hVHgHYMeta || {},
    component: () => import("/var/www/app/apps/web/pages/signup.vue")
  },
  {
    name: "offline___en",
    path: "/offline",
    component: () => import("/var/www/app/apps/web/pages/offline.vue")
  },
  {
    name: "checkout___en",
    path: "/checkout",
    meta: checkout_MyBoMLOVi14q2Tw5rSu8N9tMQzvqSxCSehoNf0_WWsMeta || {},
    component: () => import("/var/www/app/apps/web/pages/checkout.vue")
  },
  {
    name: "configure___en",
    path: "/configure",
    component: () => import("/var/www/app/apps/web/pages/configure.vue")
  },
  {
    name: "error-401___en",
    path: "/error-401",
    component: () => import("/var/www/app/apps/web/pages/error-401.vue")
  },
  {
    name: "categories___en",
    path: "/categories",
    component: () => import("/var/www/app/apps/web/pages/categories.vue")
  },
  {
    name: "contact-us___en",
    path: "/contact-us",
    component: () => import("/var/www/app/apps/web/pages/contact-us.vue")
  },
  {
    name: "order-failed___en",
    path: "/order/failed",
    meta: failedde9f5IH3QPTzPY830fzv7LZAZEbmZ5Qq2Wv_45bWVPesIMeta || {},
    component: () => import("/var/www/app/apps/web/pages/order/failed.vue")
  },
  {
    name: "find-a-dealer___en",
    path: "/find-a-dealer",
    component: () => import("/var/www/app/apps/web/pages/find-a-dealer.vue")
  },
  {
    name: "order-success___en",
    path: "/order/success",
    meta: success26CkGdzdsmwgmQjjgTiJeBv0h_muWmxvWy_MgquP0I0Meta || {},
    component: () => import("/var/www/app/apps/web/pages/order/success.vue")
  },
  {
    name: "product-slug___en",
    path: "/product/:slug()",
    meta: _91slug_93vS5_e1UzdHV_mvJve9HvVtMi7jZLFvso1MICV1dAcCwMeta || {},
    component: () => import("/var/www/app/apps/web/pages/product/[slug].vue")
  },
  {
    name: "reset-password___en",
    path: "/reset-password",
    meta: reset_45passwordmBrqHg8pYn7o11_451JtiBIJM2AHi_45l8Ivc0Iiqc9wTx8Meta || {},
    component: () => import("/var/www/app/apps/web/pages/reset-password.vue")
  },
  {
    name: "become-a-dealer___en",
    path: "/become-a-dealer",
    component: () => import("/var/www/app/apps/web/pages/become-a-dealer.vue")
  },
  {
    name: "build-your-bike___en",
    path: "/build-your-bike",
    component: () => import("/var/www/app/apps/web/pages/build-your-bike.vue")
  },
  {
    name: "category-slug___en",
    path: "/category/:slug()",
    meta: _91slug_93VVDQAJO_8wtIELIBoeQY2j1ZREtphxSKERnpGjyBANoMeta || {},
    component: () => import("/var/www/app/apps/web/pages/category/[slug].vue")
  },
  {
    name: "my-account___en",
    path: "/my-account",
    meta: indexE1s0bDIlVQ8qkcUbXNLdTT93epfXpQT7gVq3lLotZ3oMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/index.vue")
  },
  {
    name: "set-new-password___en",
    path: "/set-new-password",
    meta: set_45new_45passwordijBK_uSvyutqwZjksUBIcg3Hx5Wk5xaazm6hOAiWC4wMeta || {},
    component: () => import("/var/www/app/apps/web/pages/set-new-password.vue")
  },
  {
    name: "my-account-returns___en",
    path: "/my-account/returns",
    meta: returnst9vSGFJtHHs6_LYG1UU_45Tg3ddE_MtbDTTizDwkQ1qgYMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/returns.vue")
  },
  {
    name: "my-account-my-sales___en",
    path: "/my-account/my-sales",
    meta: my_45salesOL2sv20rZi52soJuPdz2gpptUK9p8dj08_suNA4jK4QMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/my-sales.vue")
  },
  {
    name: "my-account-warranty___en",
    path: "/my-account/warranty",
    meta: warrantyLeX_96ME7yFpuVllzbT_45RtteNWozyBjuvGVVMLXqxBMMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/warranty.vue")
  },
  {
    name: "my-account-my-account___en",
    path: "/my-account/my-account",
    meta: my_45account3n9vJbS_459OmkKd5UuWtIdF4Xp9cdRtukob8SA7CngNQMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/my-account.vue")
  },
  {
    name: "my-account-saved-cart___en",
    path: "/my-account/saved-cart",
    meta: saved_45cartecT1KF4w8sO7Tf9kmvGuzugJgEQmOihQczcPb1UieX8Meta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/saved-cart.vue")
  },
  {
    name: "reset-password-success___en",
    path: "/reset-password-success",
    meta: reset_45password_45successIXp7Q5crUcCnVN5i_45YPP3H2KDo0v1jai5agU_45n2teccMeta || {},
    component: () => import("/var/www/app/apps/web/pages/reset-password-success.vue")
  },
  {
    name: "my-account-my-customers___en",
    path: "/my-account/my-customers",
    meta: my_45customersB9pC5qLohNIAYF12rv22y_45Edl7owH1qRfnOq7sbZs2UMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/my-customers.vue")
  },
  {
    name: "my-account-my-dashboard___en",
    path: "/my-account/my-dashboard",
    meta: my_45dashboardw_y7nzY6G3l2YD_NhfGxAzqbpCiuxl7MyCmLK6E_45hqMMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/my-dashboard.vue")
  },
  {
    name: "my-account-my-discounts___en",
    path: "/my-account/my-discounts",
    meta: my_45discountsaRjSlwl5TrNek3wIhcG1htmHAS7HIEDGPutL7LOvn2AMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/my-discounts.vue")
  },
  {
    name: "my-account-my-quote-id___en",
    path: "/my-account/my-quote/:id()",
    meta: _91id_93_453KYzKJHgMNzJ4YBpNSwZ9f5JGjW1BPv7Mvq1sWYFrEMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/my-quote/[id].vue")
  },
  {
    name: "my-account-personal-data___en",
    path: "/my-account/personal-data",
    meta: personal_45data0GsQYz8jDOzqox3lGJ29mGEsHVj2Y6DYyNN12O6ZFO8Meta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/personal-data.vue")
  },
  {
    name: "my-account-my-orders-id___en",
    path: "/my-account/my-orders/:id()",
    component: () => import("/var/www/app/apps/web/pages/my-account/my-orders/[id].vue")
  },
  {
    name: "my-account-my-quote___en",
    path: "/my-account/my-quote",
    meta: indexCJQX2L1bvMl1i7xHMhei6r1On4Oz4VK7hSuczprCbMoMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/my-quote/index.vue")
  },
  {
    name: "my-account-billing-details___en",
    path: "/my-account/billing-details",
    meta: billing_45details_oEI855yh4ts_45mKTzHn8O_45WdEXG8ZoPtkvx_45W1mov3wMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/billing-details.vue")
  },
  {
    name: "my-account-my-orders___en",
    path: "/my-account/my-orders",
    meta: index6Hj89KT0Twuvcp8y7ZpTUZHGgaEE6oC3FlPsxonGo0UMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/my-orders/index.vue")
  },
  {
    name: "my-account-my-invoices-id___en",
    path: "/my-account/my-invoices/:id()",
    meta: _91id_93He_45YRrzUU7p8JQplufUM8tIIy2FoSXRjNMl2VaukeI4Meta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/my-invoices/[id].vue")
  },
  {
    name: "my-account-shipping-details___en",
    path: "/my-account/shipping-details",
    meta: shipping_45detailsw9CK_m7zTtcp4bj_45S7q_7e_knzADzn1AeMwYMHCSXWMMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/shipping-details.vue")
  },
  {
    name: "my-account-my-invoices___en",
    path: "/my-account/my-invoices",
    meta: indexpt7sEySxTygmRlWZw2oorNCs0jgpUc_esJAMFU119EcMeta || {},
    component: () => import("/var/www/app/apps/web/pages/my-account/my-invoices/index.vue")
  }
]